import React from 'react';
import { FiAward } from 'react-icons/fi';

/**
 * TrophyIcon
 * Ikona trofeje na označenie víťazov a historických záznamov žrebovania.
 */
const TrophyIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiAward className={className} {...props} />
);

export default TrophyIcon;

